import SearchFile from './SearchFile'

export default SearchFile
// eslint-disable-next-line import/export
export * from './SearchFile'
